import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5fdf33df&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=5fdf33df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf33df",
  null
  
)

export default component.exports